import React from 'react';
import { useSelector } from 'react-redux';
import BillDetailsCard from '../components/BillDetailsCard';
import CartCard from '../components/CartCard';

const CartPage = () => {
  const cartItems = useSelector((state) => state.cart);
  
  return (
    <main className="py-16">
      <div className="container 2xl:px-8 px-2 mx-auto">
        <h2 className="mb-8 text-xl font-bold">Shopping Cart</h2>
        <div className="cartListContainer">
          <div className="space-y-6">
            {cartItems.length === 0
              ? 'No Item Found'
              : cartItems.map((item) => <CartCard key={item.id} item={item} />)}
          </div>
          <div>
            <BillDetailsCard />
          </div>
        </div>
      </div>
    </main>
  );
};

export default CartPage;
